<div class="wrapper">
    @if (!isMobileSidebarOpen) {
        <button (click)="toggleMobileSidebar()"
                [attr.aria-label]="'Open menu' | translate"
                [title]="'Menu' | translate" class="mobile-menu-button"
                type="button">
            <i class="material-icons">menu</i>
    </button>
    }
    @if (isMobileSidebarOpen) {
    <button (click)="closeMobileSidebar()"
            [attr.aria-label]="'Close menu' | translate"
            class="mobile-sidebar-backdrop"
            type="button"></button>
    }
    <app-sidebar (navigationSelected)="closeMobileSidebar()" [isOpen]="isMobileSidebarOpen"></app-sidebar>
    <div class="main-panel">
        <nav class="app-topbar" id="navigation-example">
            <app-header [userInfo]="userInfo"></app-header>
        </nav>
        <main class="content">
            <router-outlet></router-outlet>
        </main>
        <footer class="app-footer">
            <app-footer></app-footer>
        </footer>
    </div>
</div>
